window.modal = {
  toggle: (id) => {
    window.modal.instances[id].toggle();
  },
  instances: [],
};
